module KendoWidgets
{
	export class NumericTextBoxOptions implements kendo.ui.NumericTextBoxOptions
	{
		name?: string;
		culture?: string;
		decimals?: number;
		downArrowText?: string;
		factor?: number;
		format?: string;
		max?: number;
		min?: number;
		placeholder?: string;
		restrictDecimals?: boolean;
		round?: boolean;
		spinners?: boolean;
		step?: number;
		upArrowText?: string;
		value?: number;
		ignoreFactor?: boolean;
		readOnly?: boolean;
		enabled?: boolean;
		defaultButtonId?: string;
		bold?: boolean;
		labelBold?: boolean;
		visible?: boolean;

		type?: NumericTypeEnum;
		width?: string | number;
		height?: string | number;
		textAlign?: TextAlignEnum;
		css?: string;
		wrapper?: string | JQuery | Element;

		label?: string;
		labelPosition?: LabelPositionEnum;
		labelClass?: string;
		labelWidth?: number;

		change?(e: kendo.ui.NumericTextBoxChangeEvent): void;
		spin?(e: kendo.ui.NumericTextBoxSpinEvent): void;
		onKeyUp?(e: KendoWidgets.NumericTextBoxKeyPressEvent): void;
		onKeyPress?(e: KendoWidgets.NumericTextBoxKeyPressEvent): void;
		onFocus?(e: KendoWidgets.NumericTextBoxFocusEvent): void;
	}

	export class NumericTextBox extends kendo.ui.NumericTextBox implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.NumericTextBox; }
		private _firstLoad: boolean;
		private _notRoundedValue: number | null;

		constructor(element: Element, options?: KendoWidgets.NumericTextBoxOptions)
		{
			if (options == null)
				options = new KendoWidgets.NumericTextBoxOptions();

			if (options.width == null) options.width = 190;
			if (options.spinners == null) options.spinners = false;
			if (options.type == null) options.type = NumericTypeEnum.Default;
			if (options.min == null) options.min = 0;
			if (options.ignoreFactor == null) options.ignoreFactor = false;
			if (options.readOnly == null) options.readOnly = false;
			if (options.enabled == null) options.enabled = true;
			if (options.textAlign == null) options.textAlign = TextAlignEnum.Right;
			if (options.visible == null) options.visible = true;

			//#region Width and Height
			if (typeof (options.width) == "number")
				options.width = options.width + "px";
			(element as HTMLElement).style.cssText += "width: " + options.width;

			if (typeof (options.height) == "number")
				options.height = options.height + "px";
			(element as HTMLElement).style.cssText += "height: " + options.height;
			//#endregion

			//#region Type
			let format = "";
			let factor = 1;
			let decimalNumbers = 0;
			switch (options.type)
			{
				case NumericTypeEnum.Default:
					{
						decimalNumbers = (options.decimals == null) ? 0 : options.decimals;
						format = "n" + decimalNumbers;
					}
					break;
				case NumericTypeEnum.Currency:
					{
						decimalNumbers = (options.decimals == null) ? 2 : options.decimals;
						format = "c" + decimalNumbers;
					}
					break;
				case NumericTypeEnum.Percentage:
					{
						if (options.decimals == null) options.decimals = 2;
						decimalNumbers = options.decimals + 2;
						format = "p" + options.decimals;
						factor = 100;
					}
					break;
			}

			options.decimals = decimalNumbers;
			options.format = (options.format != null) ? options.format : format;
			options.factor = factor;
			//#endregion

			super(element, options);
			let that = this;

			element.parentElement!.parentElement!.id = element.id + "Parent";
			$(element).parent().parent().addClass("controlParent");

			//#region Enabled
			this.enabled(options.enabled);

			if (options.readOnly || !options.enabled)
				$(element).parent().find(".k-input").attr("tabIndex", "-1");
			//#endregion

			if (!options.visible)
				this.hide();

			//#region Spinners
			if (options.spinners)
				$(element).parent().find(".k-input").css("padding-right", "30px");
			//#endregion

			//#region Label
			let label = null;
			if (options.label != null && !this._firstLoad)
			{
				this._firstLoad = true;

				$("#" + element.id + "Label").remove();
				label = document.createElement("label");
				label.id = element.id + "Label";
				$(label).kendoLabel(
					{
						text: options.label,
						color: KendoWidgets.ColorEnum.BlueVettore,
						class: options.labelClass,
						height: 20,
						fontSize: 14,
						width: (options.labelWidth != null) ? options.labelWidth : "auto"
					});

				//#region Label position
				if (options.labelPosition == null) options.labelPosition = LabelPositionEnum.Top;
				switch (options.labelPosition)
				{
					case LabelPositionEnum.Top:
						{
							$(label).addClass("k-label-top");
							element.parentElement!.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.parentElement!.insertBefore(label, element.parentElement!.parentElement!.firstChild);

							(element as HTMLElement).style.cssText += "width: 100%";
						}
						break;
					case LabelPositionEnum.Left:
						{
							$(label).addClass("k-label-left");
							element.parentElement!.parentElement!.insertBefore(label, element.parentElement!.parentElement!.firstChild);
							label.style.cssText += "margin-right: 5px";

							if (options.width == "100%")
								(element as HTMLElement).style.cssText += "width: Calc(100% - " + (label.clientWidth + 5) + "px)";
							//else
							//	(element as HTMLElement).style.cssText += "width: " + (options.width.getNumericPart() + label.clientWidth + 5) + "px !important;";
						}
						break;
					case LabelPositionEnum.Right:
						{
							$(label).addClass("k-label-right");
							element.parentElement!.parentElement!.append(label);
							label.style.cssText += "margin-left: 5px";

							if (options.width == "100%")
								(element as HTMLElement).style.cssText += "width: Calc(100% - " + (label.clientWidth + 5) + "px)";
							//else
							//	(element as HTMLElement).style.cssText += "width: " + (options.width.getNumericPart() + label.clientWidth + 5) + "px !important;";
						}
						break;
					case LabelPositionEnum.Bottom:
						{
							$(label).addClass("k-label-bottom");
							element.parentElement!.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.parentElement!.append(label);

							(element as HTMLElement).style.cssText += "width: 100%";
						}
						break;
				}
				//#endregion

				(element.parentElement!.parentElement! as HTMLElement).style.cssText += "width: " + options.width;
				$(element).parent().parent().attr("id", element.id + "Parent");

				if (options.readOnly)
					$(element).attr("readonly", "readonly");
			}
			//#endregion

			//#region KeyPress
			let onKeyPressUserOverride = options.onKeyPress;
			$(element).keypress((e) =>
			{
				let event = new NumericTextBoxKeyPressEvent();
				event.sender = that;
				event.key = e.key;
				event.keyCode = e.keyCode;
				event.shiftKeyPressed = e.shiftKey;
				event.altKeyPressed = e.altKey;
				event.ctrlKeyPressed = e.ctrlKey;
				event.enterKeyPressed = e.keyCode == 13;
				event.preventDefault = e.preventDefault;
				event.defaultPrevented = false;

				let defaultButtonId = options!.defaultButtonId;
				if (defaultButtonId != null && defaultButtonId != "" && event.enterKeyPressed)
				{
					if (defaultButtonId.startsWith("#"))
						$(defaultButtonId).click();
					else
						$("#" + defaultButtonId).click();
				}

				if (onKeyPressUserOverride != null)
				{
					onKeyPressUserOverride(event);

					if (event.defaultPrevented)
						e.preventDefault();
				}
			});
			//#endregion

			//#region KeyUp
			let onKeyUpUserOverride = options.onKeyUp;
			$(element).keyup((e) =>
			{
				let event = new NumericTextBoxKeyPressEvent();
				event.sender = that;
				event.key = e.key;
				event.keyCode = e.keyCode;
				event.shiftKeyPressed = e.shiftKey;
				event.altKeyPressed = e.altKey;
				event.ctrlKeyPressed = e.ctrlKey;
				event.enterKeyPressed = e.keyCode == 13;
				event.preventDefault = e.preventDefault;

				that._notRoundedValue = null;

				let defaultButtonId = options!.defaultButtonId;
				if (defaultButtonId != null && defaultButtonId != "" && event.enterKeyPressed)
				{
					if (defaultButtonId.startsWith("#"))
						$(defaultButtonId).click();
					else
						$("#" + defaultButtonId).click();
				}

				if (onKeyUpUserOverride != null)
					onKeyUpUserOverride(event);
			});
			//#endregion

			//#region Focus
			let onKeyFocusUserOverride = options.onFocus;
			$(element.parentElement!).find(".k-input").on("focus", (e) =>
			{
				let event = new NumericTextBoxFocusEvent();
				event.sender = that;

				window.setTimeout(() =>
				$(that.element).select());

				if (onKeyFocusUserOverride != null)
					onKeyFocusUserOverride(event);
			});
			//#endregion

			//#region Bold
			if (options.bold == true)
				$(element.parentElement!).find(".k-input").css("font-weight", 700);
			if (options.labelBold == true && label != null)
				$(label).css("font-weight", 700);
			//#endregion

			//#region Text align
			switch (options.textAlign)
			{
				case TextAlignEnum.Left: $(element.parentElement!).find(".k-input").css("text-align", "left"); break;
				case TextAlignEnum.Center: $(element.parentElement!).find(".k-input").css("text-align", "center"); break;
				case TextAlignEnum.Right: $(element.parentElement!).find(".k-input").css("text-align", "right"); break;
			}
			//#endregion

			//#region CSS
			if (options.css != null)
				(element as HTMLElement).parentElement!.parentElement!.style.cssText += options.css;
			//#endregion

			//#region Wrapper
			if (options.wrapper != null)
				window.setTimeout(() => this.element.parent().parent().wrap(options!.wrapper!));
			//#endregion
		}

		enabled(value?: boolean)
		{
			if (value != null)
			{
				(this.element[0] as HTMLInputElement).disabled = !value;
				(this.element[0].parentElement!.firstChild as HTMLInputElement).disabled = !value;

				if (value == false)
				{
					(this.element[0].parentElement!.firstChild as HTMLInputElement).style.cssText += "opacity: 0.7";
					(this.element[0] as HTMLInputElement).style.cssText += "opacity: 0.7";
				}
				else
				{
					(this.element[0].parentElement!.firstChild as HTMLInputElement).style.cssText += "opacity: 1";
					(this.element[0] as HTMLInputElement).style.cssText += "opacity: 1";
				}
			}

			return (this.element[0] as HTMLInputElement).disabled;
		}

		//#region Visible
		visible(visibleStatus?: boolean)
		{
			if (visibleStatus != null)
			{
				if (visibleStatus)
					this.element.parent().parent().show();
				else
					this.element.parent().parent().hide();
			}

			return this.element.parent().parent().is(":visible");
		}

		show()
		{
			this.visible(true);
		}

		hide()
		{
			this.visible(false);
		}
		//#endregion

		clear()
		{
			this.value("");
		}

		value(value?: number | string | null, triggerChange?: boolean)
		{
			if (typeof (value) == "string" && value != "")
				throw Error("NumericTextBox con id: '" + this.element.id + "' - Devi passare un valore numerico, non una stringa!");

			if (value === "")
			{
				super.value(value);
				this._notRoundedValue = null;

				if (triggerChange == true)
					this.trigger("change");

				return 0;
			}

			let valueToReturn = 0;
			if (value != null)
			{
				this._notRoundedValue = value;

				if ((this.options as KendoWidgets.NumericTextBoxOptions).type == NumericTypeEnum.Percentage)
					value = value / 100;

				super.value(value);
			}

			if (this._notRoundedValue != null)
			{
				if (this._notRoundedValue < 1)
					this._notRoundedValue = this._notRoundedValue * 100;
				valueToReturn = this._notRoundedValue;
			}
			else
			{
				if ((this.options as KendoWidgets.NumericTextBoxOptions).ignoreFactor == true)
					valueToReturn = super.value() * 100;
				else
				{
					let result = parseFloat((this.element[0] as HTMLInputElement).value.replace(",", "."));
					valueToReturn = isNaN(result) ? 0 : result;
				}
			}	

			if (triggerChange == true)
				this.trigger("change");

			return valueToReturn;
		}

		text()
		{
			return (this.element[0] as HTMLInputElement).value.replace(",", ".");
		}

		getOptions()
		{
			return this.options as KendoWidgets.NumericTextBoxOptions;
		}

		type(typeEnum?: NumericTypeEnum, factor: number = 100)
		{
			let options = this.getOptions();
			if (typeEnum != null)
			{
				options.type = typeEnum;
				switch (typeEnum)
				{
					case NumericTypeEnum.Default: this.setOptions({ format: "n" + options.decimals }); break;
					case NumericTypeEnum.Currency: this.setOptions({ format: "c" + options.decimals }); break;
					case NumericTypeEnum.Percentage: this.setOptions({ format: "p" + options.decimals, factor: factor }); break;
				}
			}
			return options.type;
		}

		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().parent().appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().parent().prependTo(element);
		}
	}

	NumericTextBox.fn = NumericTextBox.prototype;
	NumericTextBox.fn.options = $.extend(true, {}, kendo.ui.NumericTextBox.fn.options);
	NumericTextBox.fn.options.name = "NumericTextBox";
	kendo.ui.plugin(NumericTextBox);

	export enum NumericTypeEnum
	{
		Default,
		Percentage,
		Currency
	}

	//#region Events
	export class NumericTextBoxEvent
	{
		sender: KendoWidgets.NumericTextBox;
	}

	export class NumericTextBoxKeyPressEvent extends NumericTextBoxEvent
	{
		key: string;
		keyCode: number;
		shiftKeyPressed: boolean;
		altKeyPressed: boolean;
		ctrlKeyPressed: boolean;
		enterKeyPressed: boolean;
		preventDefault: Function;
		defaultPrevented: boolean;
	}

	export class NumericTextBoxFocusEvent extends NumericTextBoxEvent
	{

	}

	export enum TextAlignEnum
	{
		Left,
		Center,
		Right
	}
	//#endregion
}

interface JQuery
{
	kendoNumericTextBox(options?: KendoWidgets.NumericTextBoxOptions): JQuery;
}